// import React, { Component } from 'react';

// class ProgressBar extends Component {
//   render() {
//     const { step } = this.props;

//     // Calculate progress percentage
//     const progressPercent = (step - 1) * 50; // step 1 = 0%, step 2 = 50%, step 3 = 100%

//     return (
//       <div className="progress-container">
        
//         <div className="progress-wrapper">
//           <div className="progress-line-background">
//             <div className="progress-line-fill" style={{ width: `${progressPercent}%` }}></div>
//             <div className="progress-dot" style={{ left: `${progressPercent}%` }}></div>
//           </div>

//           <div className="progress-labels">
//             <span>Step 01</span>
//             <span>Step 02</span>
//             <span>Step 03</span>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default ProgressBar;




import React, { Component } from 'react';

class ProgressBar extends Component {
  render() {
    const { step } = this.props;

    const progressPercent = step === 1 ? 10 : (step === 2 ? 55 : 100); // step 1 = 0%, step 2 = 50%, step 3 = 100%
    

    return (
      <div className="progress-container">
        <div className="progress-wrapper">
          <div className="progress-line-background">
            <div className="progress-line-fill" style={{ height: `${progressPercent}%` }}></div>
            <div className="progress-dot" style={{ top: `${progressPercent}%` }}></div>
          </div>

          <div className="progress-labels">
            <span style={{ position: 'absolute', top: '10%', transform: 'translateY(-50%)' }}>Step 01</span>
            <span style={{ position: 'absolute', top: '55%', transform: 'translateY(-50%)' }}>Step 02</span>
            <span style={{ position: 'absolute', top: '100%', transform: 'translateY(-50%)' }}>Step 03</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ProgressBar;